<div class="bp-shell">

  <!-- ───────────────── Header ───────────────── -->
  <header class="bp-header glass">
    <div class="bp-brand">
      <div class="bp-brand-text">
        <p>Bill Payments Dashboard</p>
      </div>
    </div>

    <div class="bp-search">
      <i class="fa-solid fa-magnifying-glass"></i>

      <input
        type="text"
        placeholder="Search services..."
        [ngModel]="search()"
        (ngModelChange)="onSearchChanged($event)"
      />
    </div>

    <div class="bp-header-actions">
      <div class="profile-pill">
        <div class="avatar">
          {{
            (
              (userInfo?.firstName?.charAt(0) || '') +
              (userInfo?.lastName?.charAt(0) || '')
            ).toUpperCase()
          }}
        </div>

        <div class="profile-meta">
          <span>
            {{ userInfo?.firstName }}
            {{ userInfo?.lastName }}
          </span>
        </div>
      </div>
    </div>
  </header>

  <!-- ───────────────── Bill Payments ───────────────── -->
  <section class="bill-payment-section">

    <!-- Heading -->
    <div class="section-head">
      <h2>Bill Payments</h2>

      <!-- Only service count stays at the top -->
      <div class="section-head-actions">
        <span class="count">
          {{ filtered().length }} services
        </span>
      </div>
    </div>

    <!-- ───────────────── Loading Skeleton ───────────────── -->
    <div
      class="grid"
      *ngIf="loading()"
    >
      <div
        class="skeleton"
        *ngFor="let skeleton of skeletons"
      ></div>
    </div>

    <!-- ───────────────── Empty Search Result ───────────────── -->
    <div
      class="empty"
      *ngIf="
        !loading() &&
        filtered().length === 0
      "
    >
      <i class="fa-regular fa-face-frown-open"></i>

      <h3>No results found</h3>

      <p>
        Try adjusting your search.
      </p>
    </div>

    <!-- ───────────────── Service Cards ───────────────── -->
    <div
      class="grid"
      *ngIf="
        !loading() &&
        filtered().length > 0
      "
    >
      <article
        class="service-card"
        *ngFor="
          let service of visibleServices();
          trackBy: trackById
        "
        [class.maintenance]="
          service.status === 'maintenance'
        "
        (click)="goToProviderList(service)"
      >
        <!-- Service Icon -->
        <div
          class="icon-wrap"
          [style.background]="service.gradient"
        >
          <i [class]="service.icon"></i>
        </div>

        <!-- Service Name -->
        <h3>
          {{ service.name }}
        </h3>

        <!-- Service Description -->
        <p class="cat">
          {{ service.category }}
        </p>

        <!-- Availability Status -->
        <div class="status">
          <span
            class="status-dot"
            [class.active]="
              service.status === 'active'
            "
            [class.warn]="
              service.status === 'maintenance'
            "
          ></span>

          <small>
            {{
              service.status === "active"
                ? "Available"
                : "Maintenance"
            }}
          </small>
        </div>

        <!-- Existing Explore Button -->
        <button
          type="button"
          class="pay-btn"
          [disabled]="
            service.status !== 'active'
          "
          (click)="
            goToProviderList(service);
            $event.stopPropagation()
          "
        >
          Explore More

          <i
            class="fa-solid fa-arrow-right-long"
          ></i>
        </button>
      </article>
    </div>

    <!-- ───────────────── Bottom Right More / Less ───────────────── -->
    <div
      class="services-bottom-actions"
      *ngIf="
        !loading() &&
        filtered().length > 0 &&
        canToggleServices
      "
    >
      <button
        type="button"
        class="service-toggle-btn"
        [attr.aria-expanded]="
          showAllServices()
        "
        [attr.aria-label]="
          showAllServices()
            ? 'Show fewer bill payment services'
            : 'Show all bill payment services'
        "
        (click)="toggleServices()"
      >
        <span>
          {{
            showAllServices()
              ? "Less"
              : "More"
          }}
        </span>

        <i
          [class]="
            showAllServices()
              ? 'fa-solid fa-chevron-up'
              : 'fa-solid fa-chevron-down'
          "
        ></i>
      </button>
    </div>

  </section>
</div>

<!-- ───────────────── Existing Biller Operator Popup ───────────────── -->
<app-biller-operator
  [open]="isBillerOperatorPopupOpen"
  [category]="selectedCategory"
  [userId]="currentUserId"
  (closed)="closeBillerOperatorPopup()"
  (completed)="onBillerOperatorCompleted($event)"
>
</app-biller-operator>
